/**
 * - `production`: The production environment
 * - `development`: The local environment
 * - `test`: Test environment or running tests
 */
export type EnvironmentName = 'production' | 'development' | 'test';

export const environmentName = process.env.NODE_ENV as EnvironmentName;

export const isLocalEnv = environmentName === 'development';
export const isTestEnv = environmentName === 'test';
export const isLocalOrTestEnv = isLocalEnv || isTestEnv;

export const featureFlags = {
  /** Redirect users with an unfinished registration from login to email verification */
  completeUnfinishedRegistration: isLocalOrTestEnv,
} satisfies Record<string, boolean>;
